"use strict";
// Profile editing, in three flavours:
// - "self": the unlocked profile edits itself (name, avatar, PIN, recovery phrase, deletion);
// - "admin": the owner manages another profile (parental controls, deletion) without seeing
//   its history, PIN or recovery phrase;
// - "create": the owner adds a profile; its person sets their own PIN later.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var components_2 = require("stremio/routes/Settings/components");
var api_1 = __importStar(require("stremio/plus/api"));
var kids_1 = require("stremio/plus/kids");
var avatars_1 = require("./avatars");
var ProfileAvatar_1 = __importDefault(require("./ProfileAvatar"));
var AvatarPicker_1 = __importDefault(require("./AvatarPicker"));
var PinInput_1 = __importDefault(require("./PinInput"));
var ProfileGate_less_1 = __importDefault(require("./ProfileGate.less"));
var PIN_PATTERN = /^\d{4}$/;
var ProfileEditor = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var kind = _a.kind, authKey = _a.authKey, token = _a.token, profile = _a.profile, mainHasPin = _a.mainHasPin, onDone = _a.onDone, onShowPhrase = _a.onShowPhrase;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _j = (0, react_1.useState)((_b = profile === null || profile === void 0 ? void 0 : profile.name) !== null && _b !== void 0 ? _b : ''), name = _j[0], setName = _j[1];
    var _k = (0, react_1.useState)(function () { return (profile === null || profile === void 0 ? void 0 : profile.avatar) && (0, avatars_1.parseAvatar)(profile.avatar) ? profile.avatar : (0, avatars_1.makeAvatar)(avatars_1.DEFAULT_AVATAR_STYLE, (0, avatars_1.randomSeed)()); }), avatar = _k[0], setAvatar = _k[1];
    var _l = (0, react_1.useState)((_c = profile === null || profile === void 0 ? void 0 : profile.isKids) !== null && _c !== void 0 ? _c : false), isKids = _l[0], setIsKids = _l[1];
    var _m = (0, react_1.useState)((_d = profile === null || profile === void 0 ? void 0 : profile.maxAge) !== null && _d !== void 0 ? _d : 10), maxAge = _m[0], setMaxAge = _m[1];
    var _o = (0, react_1.useState)((_e = profile === null || profile === void 0 ? void 0 : profile.hasPin) !== null && _e !== void 0 ? _e : false), pinEnabled = _o[0], setPinEnabled = _o[1];
    var _p = (0, react_1.useState)(''), currentPin = _p[0], setCurrentPin = _p[1];
    var _q = (0, react_1.useState)(''), newPin = _q[0], setNewPin = _q[1];
    var _r = (0, react_1.useState)(''), confirmation = _r[0], setConfirmation = _r[1];
    var _s = (0, react_1.useState)(false), confirmDelete = _s[0], setConfirmDelete = _s[1];
    var _t = (0, react_1.useState)(false), saving = _t[0], setSaving = _t[1];
    var _u = (0, react_1.useState)(null), error = _u[0], setError = _u[1];
    var isMain = (_f = profile === null || profile === void 0 ? void 0 : profile.isMain) !== null && _f !== void 0 ? _f : false;
    var hasPin = (_g = profile === null || profile === void 0 ? void 0 : profile.hasPin) !== null && _g !== void 0 ? _g : false;
    var showIdentity = kind !== 'admin';
    var showParental = (kind === 'admin' || kind === 'create') && !isMain;
    var showSecurity = kind === 'self';
    var canDelete = profile !== null && !isMain && kind !== 'create';
    var removingPin = hasPin && !pinEnabled;
    var changingPin = pinEnabled && newPin.length > 0;
    var needsCurrentPin = hasPin && (removingPin || changingPin);
    var pinValid = !changingPin || (PIN_PATTERN.test(newPin) && confirmation === newPin);
    var newPinRequired = pinEnabled && !hasPin && !PIN_PATTERN.test(newPin);
    var canSave = !saving && (!showIdentity || name.trim().length > 0) && pinValid && !newPinRequired &&
        (!needsCurrentPin || PIN_PATTERN.test(currentPin));
    var ageOptions = (0, react_1.useMemo)(function () { return kids_1.KIDS_AGE_OPTIONS.map(function (age) { return ({ label: t('PLUS_PROFILES_AGE', { age: age }), value: age }); }); }, [t]);
    var describe = (0, react_1.useCallback)(function (e) {
        if (e instanceof api_1.PlusApiError && e.code === api_1.ERROR_WRONG_PIN)
            return t('PLUS_PROFILES_WRONG_CURRENT_PIN');
        if (e instanceof api_1.PlusApiError && e.code === api_1.ERROR_PIN_LOCKED)
            return t('PLUS_RECOVERY_LOCKED');
        return e.message;
    }, [t]);
    var save = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var recoveryPhrase, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSaving(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, , 10]);
                    if (!(kind === 'create')) return [3 /*break*/, 3];
                    return [4 /*yield*/, api_1.default.saveProfile(authKey, token, { name: name, avatar: avatar, isKids: isKids, maxAge: maxAge })];
                case 2:
                    _a.sent();
                    onDone();
                    return [2 /*return*/];
                case 3:
                    if (!(kind === 'admin')) return [3 /*break*/, 5];
                    return [4 /*yield*/, api_1.default.saveProfile(authKey, token, { id: profile.id, isKids: isKids, maxAge: maxAge })];
                case 4:
                    _a.sent();
                    onDone();
                    return [2 /*return*/];
                case 5: return [4 /*yield*/, api_1.default.saveProfile(authKey, token, { id: profile.id, name: name, avatar: avatar })];
                case 6:
                    _a.sent();
                    if (!(removingPin || changingPin)) return [3 /*break*/, 8];
                    return [4 /*yield*/, api_1.default.setPin(authKey, token, profile.id, removingPin ? null : newPin, hasPin ? currentPin : undefined)];
                case 7:
                    recoveryPhrase = (_a.sent()).recoveryPhrase;
                    // A first PIN comes with its recovery phrase, shown once before leaving.
                    if (recoveryPhrase) {
                        onShowPhrase(recoveryPhrase, name, function () { return onDone(); });
                        return [2 /*return*/];
                    }
                    _a.label = 8;
                case 8:
                    onDone();
                    return [3 /*break*/, 10];
                case 9:
                    e_1 = _a.sent();
                    setError(describe(e_1));
                    setSaving(false);
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); }, [kind, authKey, token, profile, name, avatar, isKids, maxAge, removingPin, changingPin, newPin, hasPin, currentPin, onDone, onShowPhrase, describe]);
    // Viewing or replacing the recovery phrase needs the current PIN again.
    var showRecovery = (0, react_1.useCallback)(function (regenerate) { return __awaiter(void 0, void 0, void 0, function () {
        var recoveryPhrase, _a, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!regenerate) return [3 /*break*/, 3];
                    return [4 /*yield*/, api_1.default.regenerateRecoveryPhrase(authKey, token, profile.id, currentPin)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, api_1.default.getRecoveryPhrase(authKey, token, profile.id, currentPin)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    recoveryPhrase = (_a).recoveryPhrase;
                    if (recoveryPhrase)
                        onShowPhrase(recoveryPhrase, name, function () { return onDone(); });
                    return [3 /*break*/, 7];
                case 6:
                    e_2 = _b.sent();
                    setError(describe(e_2));
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [authKey, token, profile, currentPin, name, onShowPhrase, onDone, describe]);
    var remove = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!profile)
                        return [2 /*return*/];
                    if (!confirmDelete) {
                        setConfirmDelete(true);
                        return [2 /*return*/];
                    }
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api_1.default.deleteProfile(authKey, token, profile.id)];
                case 2:
                    _a.sent();
                    onDone(profile.id);
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _a.sent();
                    setError(describe(e_3));
                    setSaving(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [authKey, token, profile, confirmDelete, onDone, describe]);
    var title = kind === 'create' ? t('PLUS_PROFILES_ADD') : kind === 'admin' ? t('PLUS_PROFILES_ADMIN', { name: profile === null || profile === void 0 ? void 0 : profile.name }) : t('PLUS_PROFILES_EDIT');
    return (react_1.default.createElement("div", { className: ProfileGate_less_1.default['editor'] },
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['editor-heading'] },
            react_1.default.createElement(ProfileAvatar_1.default, { profile: { name: name || (profile === null || profile === void 0 ? void 0 : profile.name) || '?', avatar: showIdentity ? avatar : (_h = profile === null || profile === void 0 ? void 0 : profile.avatar) !== null && _h !== void 0 ? _h : avatar } }),
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['title'] }, title)),
        showIdentity ?
            react_1.default.createElement(components_2.Section, { label: 'PLUS_PROFILES_SECTION_PROFILE' },
                react_1.default.createElement(components_2.Option, { label: 'PLUS_PROFILES_NAME' },
                    react_1.default.createElement(components_1.TextInput, { className: ProfileGate_less_1.default['text-input'], placeholder: t('PLUS_PROFILES_NAME'), maxLength: 32, value: name, onChange: function (event) { return setName(event.target.value); } })),
                react_1.default.createElement(AvatarPicker_1.default, { value: avatar, onChange: setAvatar }))
            :
                null,
        showParental ?
            react_1.default.createElement(components_2.Section, { label: 'PLUS_PROFILES_SECTION_PARENTAL' },
                react_1.default.createElement(components_2.Option, { label: 'PLUS_PROFILES_KIDS_OPTION' },
                    react_1.default.createElement(components_1.Toggle, { checked: isKids, onClick: function () { return setIsKids(!isKids); } })),
                isKids ?
                    react_1.default.createElement(components_2.Option, { label: 'PLUS_PROFILES_MAX_AGE' },
                        react_1.default.createElement(components_1.MultiselectMenu, { className: 'multiselect', options: ageOptions, value: maxAge, onSelect: function (age) { return setMaxAge(age); } }))
                    :
                        null,
                isKids ? react_1.default.createElement("div", { className: ProfileGate_less_1.default['hint'] }, t('PLUS_PROFILES_KIDS_HINT')) : null,
                isKids && !mainHasPin ? react_1.default.createElement("div", { className: ProfileGate_less_1.default['warning'] }, t('PLUS_PROFILES_KIDS_NEEDS_MAIN_PIN')) : null,
                kind === 'admin' ? react_1.default.createElement("div", { className: ProfileGate_less_1.default['hint'] }, t('PLUS_PROFILES_ADMIN_PRIVACY')) : null,
                kind === 'create' ? react_1.default.createElement("div", { className: ProfileGate_less_1.default['hint'] }, t('PLUS_PROFILES_CREATE_PIN_HINT')) : null)
            :
                null,
        showSecurity ?
            react_1.default.createElement(components_2.Section, { label: 'PLUS_PROFILES_SECTION_SECURITY' },
                react_1.default.createElement(components_2.Option, { label: 'PLUS_PROFILES_PIN_OPTION' },
                    react_1.default.createElement(components_1.Toggle, { checked: pinEnabled, disabled: isMain, onClick: function () { return !isMain && setPinEnabled(!pinEnabled); } })),
                isMain ? react_1.default.createElement("div", { className: ProfileGate_less_1.default['hint'] }, t('PLUS_PROFILES_MAIN_PIN_REQUIRED')) : null,
                hasPin ?
                    react_1.default.createElement(components_2.Option, { label: 'PLUS_PROFILES_CURRENT_PIN' },
                        react_1.default.createElement(PinInput_1.default, { value: currentPin, onChange: setCurrentPin }))
                    :
                        null,
                pinEnabled ?
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(components_2.Option, { label: hasPin ? 'PLUS_PROFILES_NEW_PIN_OPTIONAL' : 'PLUS_PROFILES_NEW_PIN' },
                            react_1.default.createElement(PinInput_1.default, { value: newPin, onChange: setNewPin })),
                        newPin.length > 0 ?
                            react_1.default.createElement(components_2.Option, { label: 'PLUS_PROFILES_CONFIRM_PIN' },
                                react_1.default.createElement(PinInput_1.default, { value: confirmation, onChange: setConfirmation, invalid: confirmation.length === 4 && confirmation !== newPin }))
                            :
                                null)
                    :
                        null,
                hasPin ?
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: ProfileGate_less_1.default['hint'] }, t('PLUS_RECOVERY_SECTION_HINT')),
                        react_1.default.createElement("div", { className: ProfileGate_less_1.default['avatar-actions'] },
                            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(ProfileGate_less_1.default['button'], ProfileGate_less_1.default['shuffle']), disabled: !PIN_PATTERN.test(currentPin), onClick: function () { return showRecovery(false); } }, t('PLUS_RECOVERY_SHOW')),
                            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(ProfileGate_less_1.default['button'], ProfileGate_less_1.default['shuffle']), disabled: !PIN_PATTERN.test(currentPin), onClick: function () { return showRecovery(true); } }, t('PLUS_RECOVERY_REGENERATE'))))
                    :
                        null)
            :
                null,
        error !== null ? react_1.default.createElement("div", { className: ProfileGate_less_1.default['error'] }, error) : null,
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['actions'] },
            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(ProfileGate_less_1.default['button'], ProfileGate_less_1.default['primary']), disabled: !canSave, onClick: save }, t('PLUS_PROFILES_SAVE')),
            react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['button'], onClick: function () { return onDone(); } }, t('PLUS_PROFILES_CANCEL')),
            canDelete ?
                react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(ProfileGate_less_1.default['button'], ProfileGate_less_1.default['danger']), disabled: saving, onClick: remove }, confirmDelete ? t('PLUS_PROFILES_DELETE_CONFIRM') : t('PLUS_PROFILES_DELETE'))
                :
                    null),
        confirmDelete ? react_1.default.createElement("div", { className: ProfileGate_less_1.default['warning'] }, t('PLUS_PROFILES_DELETE_WARNING')) : null));
};
exports.default = ProfileEditor;
